import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RingVolumeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"ring_volume"}/>
}
